<script setup>
import { defineOptions } from 'vue';

defineOptions({
  name: 'Pagination'
});

const emits = defineEmits(['go']);

defineProps({
  item: Object,
  icon: {
    type: Object,
    default: {
      prev: 'fa-solid fa-backward',
      next: 'fa-solid fa-forward',
    }
  },
  enableLessAndMore: {
    type: Boolean,
    default: true,
  },
  enableFirstAndLast: {
    type: Boolean,
    default: true,
  }
});

function goToPage(v) {
  emits('go', v);
}

</script>

<template>
  <nav v-if="item.total > 1" aria-label="navigation">
    <ul class="pagination c-pagination">

      <li v-if="item.first && enableFirstAndLast" class="page-item page-item--first"
        @click="goToPage(item.first)"
      >
        <span class="page-link">
          <i class="fa-solid fa-backward-step"></i>
        </span>
      </li>

      <li v-if="item.prev && item.prev >= 1" class="page-item page-item--previous"
        @click="goToPage(item.prev)"
      >
        <span class="page-link">
          <i :class="icon.prev"></i>
        </span>
      </li>

      <li v-if="item.less && enableLessAndMore" class="page-item page-item--less d-none d-md-block"
        @click="goToPage(item.less)"
      >
        <span class="page-link">
          Less
        </span>
      </li>

      <li v-for="pageItem in item.pages" class="page-item"
        :class="[ 'page-item--' + pageItem.page, { 'active': pageItem.name === 'current' } ]"
        @click="goToPage(pageItem.page)"
      >
        <span class="page-link">
          {{ pageItem.page }}
        </span>
      </li>

      <li v-if="item.more && enableLessAndMore" class="page-item page-item--more d-none d-md-block"
        @click="goToPage(item.more)"
      >
        <span class="page-link">
          More
        </span>
      </li>

      <li v-if="item.next" class="page-item page-item--next"
        @click="goToPage(item.next)"
      >
        <span class="page-link">
          <i :class="icon.next"></i>
        </span>
      </li>

      <li v-if="item.last && enableFirstAndLast" class="page-item last"
        @click="goToPage(item.last)"
      >
        <span class="page-link">
          <i class="fa-solid fa-forward-step"></i>
        </span>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.page-link {
  cursor: pointer;
}
</style>
